import classNames from "classnames";
import React from "react";
import styles from "./inputButton.css";
import pickerBtnStyles from "../../../MessagePickerWidget/MessagePickerWidget.css";

interface Props {
  onClick(): void;
  disabled?: boolean;
  primary?: boolean;
}
export const InputButton = ({
  onClick,
  disabled,
  primary,
  children
}: React.PropsWithChildren<Props>) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={classNames(styles["input-button"], { [pickerBtnStyles.primary]: !!primary })}
    >
      {children}
    </button>
  );
};
